export default "__VITE_ASSET__8KwRwc1S__"